import styled from "styled-components"


export const GenericCardsContainer = styled.div`
    display: flex;
    width: 100%;
    overflow: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch; /* For iOS devices */
/* Hide scrollbar for Chrome, Safari and Opera */
::-webkit-scrollbar {
    display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
-ms-overflow-style: none;  /* IE and Edge */
scrollbar-width: none; /* Firefox */

    padding: 20px;
    @media(min-width: 768px){
        padding: 35px;
    }
    @media(min-width: 1024px){
         padding: 50px;
    }

`

export const GenericCardBackground = styled.img`
    height: 100%;
    width: 100%;
    transition: transform 0.5s ease-in-out;
`

export const AppExclusiveContainer = styled.div`
    display: flex;
    width: 80%;
    flex-direction: column;
    align-items: center;
    position: absolute;
    bottom: 0;    
    color: #FFFFFF;

    transform: translateY(30px);
    transition: transform 0.5s ease-in-out;
    @media (min-width: 768px) {
        transform: translateY(35px);
    }

`

export const AppExclusiveText = styled.div`
    background: rgba(0, 0, 0, 0.44);
    backdrop-filter: blur(8.5px);
    /* Note: backdrop-filter has minimal browser support */
    text-align: center;
    display: flex;
    align-items: center;
    gap: 3px;
    
    font-size: 8px;
    margin-top: 8px;
    padding: 2px 5px;
    border-radius: 15px;

    @media(min-width: 768px){
        font-size: 12px;
        margin-top: 10px;
        padding: 3px 5px;
        border-radius: 20px;
    }
    @media(min-width: 1024px){
        font-size: 16px;
        margin-top: 12px;
        padding: 5px 10px;
        border-radius: 25px;
    }
`

export const GenericCardCategory = styled.div`    
    background: rgba(0, 0, 0, 0.38);
    backdrop-filter: blur(14px);
    color: #FFFFFF;
    font-family: 'heroregular';
    font-style: normal;
    font-weight: 400;
    width: fit-content;
    cursor: default;

    padding: 2px;
    border-radius: 16px;
    font-size: 10px;
    line-height: 8px;

    @media(min-width: 768px){
        padding: 4px;
        border-radius: 21px;
        font-size: 12px;
        line-height: 12px;
    }
    @media(min-width: 1024px){
        padding: 7px;
        border-radius: 28px;
        font-size: 16px;
        line-height: 16px;
    }
`

export const GenericCardTitle = styled.div`
    color: #FFFFFF;
    font-family: 'heroregular';
    font-style: normal;
    display: flex;
    justify-content: center;
    cursor: default;
    text-align: center;
    line-height: 1.1;

    width: 107px;
    font-weight: 600;
    font-size: 16px;
    @media(min-width: 768px){
        width: 187px;
        font-weight: 600;
        font-size: 21px;
    }
    @media(min-width: 1024px){
        width: 287px;
        font-weight: 600;
        font-size: 28px;
    }
`

export const GenericCardContainer = styled.div`
    flex: 0 0 129px;
    height: 138px;
    margin-right: 30px;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    cursor: pointer;
    &:hover {
        ${GenericCardBackground} {
            transform: scale(1.05);
        }
        ${AppExclusiveContainer} {
            transform: translateY(-10px);
            @media (min-width: 768px) {
                transform: translateY(-15px);
            }
            @media(min-width: 1024px){
                transform: translateY(-20px);
            }
        }
    }
    @media(min-width: 768px){
        flex: 0 0 229px;
        height: 238px;
        margin-right: 60px;
        border-radius: 8px;
    }
    @media(min-width: 1024px){
        flex: 0 0 329px;
        height: 338px;
        margin-right: 90px;
        border-radius: 10px;
    }
`;